var React = require('react');

function DeleteIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.857143 14.2222C0.857143 15.2 1.62857 16 2.57143 16H9.42857C10.3714 16 11.1429 15.2 11.1429 14.2222V3.55556H0.857143V14.2222ZM2.57143 5.33333H9.42857V14.2222H2.57143V5.33333ZM9 0.888889L8.14286 0H3.85714L3 0.888889H0V2.66667H12V0.888889H9Z","fill":"#595959"}));
}

DeleteIcon.defaultProps = {"width":"12","height":"16","viewBox":"0 0 12 16","fill":"none"};

module.exports = DeleteIcon;

DeleteIcon.default = DeleteIcon;
